// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1tCP9","productName":"Table_productName__3h6eR"};